export const SCOPES_OPTIONS = { IN_SCOPE: 1, OUT_SCOPE: 2 };

export const SCOPES_TITLE = {
    [SCOPES_OPTIONS.IN_SCOPE]: 'In scope',
    [SCOPES_OPTIONS.OUT_SCOPE]: 'Out of scope'
};
export const SCOPES_COLOR = {
    [SCOPES_OPTIONS.IN_SCOPE]: 'bg-sf-positive-500',
    [SCOPES_OPTIONS.OUT_SCOPE]: 'bg-sf-negative-500'
};
